export enum DataEditSourceType {
    Workbook = 0,
    Qnr = 1,
    OrbitaxConnect = 2,
    DirectEdit = 3,
    EATWorkflow = 4,
    ImportExcel = 5,
    ItpFields = 6,
    Scenario = 7,
    Blank = 8
}

export interface IDataSourceChartItem {
    sourceTitle: string;
    dataEditSourceType: DataEditSourceType;
    numberOfRecordsEdited: number;
    colorCode: string;
}

export interface IDataSource {
    sourceTitle: string;
    sourceIcon: string;
    dataEditSourceType: DataEditSourceType;
}

export interface IChart<T> {
    chartType: string;
    categoryField: string;
    field: string;
    colorField: string;
    chartAreaBackgroundColor: string;
    holeSize: number;
    chartItems: T[];
}
export interface IDataTracingResponse {
    summaryTitle: string;
    dataEditSummaryId: string;
    destinationType: string;

    // The specific chart definition
    dataSourceChart: IChart<IDataSourceChartItem>;

    dataSources: IDataSource[];
}

export interface IDataTracingEnhancedRecord {
    title: string;
    toolTip: string;
    referenceCode: string;
    latestDataEditHistoryId: string;
    columnIndex: string;
    rowIndex: string;
    recordCount: number;
}

export type DataTracingPageDto =
{
    id : string; // this is random guid
    key: string; // this is page id
    title: string;
    documentId: string;
}

export type EnhancedDataTracingRecordMap = {[key: string]: IDataTracingEnhancedRecord[]};

export function generateTracingKey(dataSource: IDataSource, indexValue: string): string
{
    return `${dataSource.dataEditSourceType}__${indexValue}`;
}
